import unconfirmedBooking from '@/http/services/unconfirmed-booking'
import store from '../../../store'
export default {
  cancel ({ commit }, id) {
    return unconfirmedBooking.cancel(store.state.apiUrl, id).then((booking) => {
      return booking.data
    })
  },
  confirm ({ commit }, id) {
    return unconfirmedBooking.confirm(store.state.apiUrl, id).then((booking) => {
      return booking.data
    })
  },
}
